import { newNeuroThreeTariffsListId, newNeuroThreeTariffsPopupTitle } from 'reactApp/appHelpers/featuresHelpers/features/aiTariff';
import { openBuyDisableAds, openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { closePopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { Product } from 'reactApp/types/Billing';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';
import { getDiscount } from 'reactApp/utils/getDiscount';
import { getFirstSomePeriodsAsWord, getPeriodName, isYearPeriod } from 'reactApp/utils/Period';
import { formatPrice } from 'reactApp/utils/priceHelpers';
import type { AnyAction, Dispatch } from 'redux';

export const getMidasDescription = (product: Product): string => {
    if (!product) {
        return '';
    }

    const { hasDiscount, trialPeriod, discountPeriodCount, discountPeriod, isOnlyFeatures, hasTrial, isFamily, discountPrice, price } =
        product;

    const trialPeriodName = trialPeriod && getPeriodName(trialPeriod, false, false, true).replace('\u00A0', '');
    const discountPeriodName =
        discountPeriod &&
        getFirstSomePeriodsAsWord(discountPeriodCount || 1, isYearPeriod(discountPeriod) ? 'y' : 'm').replace('\u00A0', '');

    if (product && isFamily && isOnlyFeatures && !hasTrial) {
        return `Семейные функции на ${getPeriodName(product.discountPeriod || product.period, false, true)}`;
    }

    const spaceText = `+${product.space.space} ${product.space.units}`;

    if (hasDiscount && trialPeriodName && discountPeriodName && !isOnlyFeatures) {
        return `${spaceText} на ${trialPeriodName} бесплатно, далее ${formatPrice(product.discountPrice)} ₽ в ${discountPeriodName}`;
    }

    if (trialPeriodName && !isOnlyFeatures) {
        return `${spaceText} на ${trialPeriodName} бесплатно, далее ${formatPrice(product.price)} ₽ в ${getPeriodName(product.period)}`;
    }

    if (trialPeriodName) {
        return 'Для проверки карты мы спишем и сразу же вернем 1 ₽';
    }

    if (discountPeriodName) {
        const { discount } = getDiscount({ discountPrice: discountPrice || 0, price });

        return `${spaceText} на ${discountPeriodName} со скидкой ${discount}%`;
    }

    return '';
};

export const openThreeTariffsPopup = ({
    dispatch,
    paySource,
    title = newNeuroThreeTariffsPopupTitle,
    buyTitle = '',
    tariffsId = newNeuroThreeTariffsListId,
}: {
    dispatch: Dispatch<AnyAction>;
    paySource: string;
    title?: string;
    buyTitle?: string;
    tariffsId?: string;
}) => {
    dispatch(
        openBuyDisableAds({
            title,
            tariffsNumber: tariffsId,
            activeTab: ETabsName.year,
            isFrame: false,
            onBuyClick: (product: Product) =>
                dispatch(
                    openTariffBuy({
                        productId: product.id,
                        title: buyTitle,
                        paySource,
                        onSuccess: () => closePopupHelper(popupNames.BUY_DISABLE_ADS),
                    })
                ),
            paySource,
        })
    );
};
